// История изменений: кто, когда, какое поле, из чего во что.
//
// ЗАЧЕМ ИМЕННО В ТАКОМ ВИДЕ. «Изменена сделка 12.05.2026, Петров» — это не история, это
// уведомление: по нему нельзя ни найти, кто поставил не ту сумму, ни вернуть прежнее
// значение. Спор «я этого не ставил» разрешается только парой «из чего во что», и она же
// объясняет, почему у сделки вдруг сменилась стадия — ручная правка или бизнес-процесс.
//
// ПОЧЕМУ ЗНАЧЕНИЯ ХРАНЯТСЯ ТЕКСТОМ. Журнал читают, а не разбирают: показать «из „Сбор
// данных“ в „Отгрузка товара“» важнее, чем уметь восстановить `C4:5`. Код стадии в журнале
// через год окажется мёртвым, а подпись останется понятной.

import { plural } from '../lib/format'

import { равны, текстЗначения } from './values'
import type { ЗаписьЖурнала, Значения, Поле } from './types'

/**
 * Разница между двумя наборами значений — готовыми записями журнала.
 *
 * Смотрим по ОПИСАНИЮ полей, а не по ключам объекта: значение, которого нет ни в одном
 * поле карточки, человеку показать нечем — у него нет ни подписи, ни вида.
 */
export function изменения(
  поля: Поле[],
  было: Значения,
  стало: Значения,
  кто: string,
  ревизия: number,
  когда = new Date().toISOString(),
): ЗаписьЖурнала[] {
  const записи: ЗаписьЖурнала[] = []
  for (const п of поля) {
    const a = было[п.код]
    const b = стало[п.код]
    if (равны(a, b)) continue
    записи.push({
      ревизия,
      когда,
      кто,
      операция: 'update',
      поле: п.код,
      подписьПоля: п.подпись,
      // Каждая половина читается в СВОЁМ окружении: смена воронки переименовывает стадию,
      // и «из „Отправка счета“ во „В работе“» — правда только если брать подписи из своих
      // значений, а не из одних и тех же.
      из: текстЗначения(п, a, было),
      во: текстЗначения(п, b, стало),
      откуда: 'ui',
    })
  }
  return записи
}

/** Коды полей, которые изменены относительно исходных значений. */
export function изменённые(поля: Поле[], было: Значения, стало: Значения): Set<string> {
  const s = new Set<string>()
  for (const п of поля) if (!равны(было[п.код], стало[п.код])) s.add(п.код)
  return s
}

/**
 * «Не сохранено: три поля» — подпись для шапки.
 *
 * Число и слово вместе, потому что порознь их однажды подставят разными: `plural` живёт
 * в `lib/format` и одна на всю CRM.
 */
export function сколькоНеСохранено(n: number): string {
  return `${n} ${plural(n, 'поле', 'поля', 'полей')}`
}

/** Журнал сверху вниз: самое свежее первым. */
export function поСвежести(записи: ЗаписьЖурнала[]): ЗаписьЖурнала[] {
  return [...записи].sort((a, b) => b.когда.localeCompare(a.когда) || b.ревизия - a.ревизия)
}
